import './EditCountries.sass';

import React, { FC, useCallback, useMemo, useState } from 'react';
import Select from 'react-select';
import { useDispatch } from 'react-redux';

import { BottomBar, Button, Form, FormItem, Header } from '$uikit';
import { IcDropdown16 } from '$assets';
import { profileActions } from '$store/profile';
import { useCurrentUserInfo, useTranslator } from '$hooks';

import allCountries from './countries.json';

export const EditCountries: FC = () => {
  const dispatch = useDispatch();
  const t = useTranslator();
  const user = useCurrentUserInfo();

  const countriesMap = useMemo(() => {
    const ret = {};
    for (let item of allCountries) {
      ret[item.code] = item.name;
    }
    return ret;
  }, []);

  const [countries, setCountries] = useState<null | { value: string; label: string }[]>(
    user.availCountries
      ? user.availCountries.map((code) => ({
          value: code,
          label: countriesMap[code],
        }))
      : null,
  );

  const handleChange = useCallback((newValue) => {
    setCountries(newValue);
  }, []);

  const options = useMemo(() => {
    return allCountries.map((item) => ({
      value: item.code,
      label: item.name,
    }));
  }, []);

  const handleSave = useCallback(() => {
    dispatch(
      profileActions.saveCountries(countries ? countries.map((item) => item.value) : []),
    );
  }, [dispatch, countries]);

  return (
    <>
      <Header showCloseButton>{t('edit_countries_title')}</Header>
      <div className="EditCountries__description">{t('edit_countries_caption')}</div>
      <Form>
        <FormItem>
          <Select
            classNamePrefix="Select"
            isSearchable
            isMulti
            value={countries}
            onChange={handleChange}
            options={options}
            placeholder={t('edit_countries_placeholder')}
            noOptionsMessage={() => t('edit_countries_not_found')}
            components={{
              DropdownIndicator: () => <IcDropdown16 />,
            }}
          />
        </FormItem>
      </Form>
      <BottomBar>
        <Button onClick={handleSave} stretched>
          {t('save')}
        </Button>
      </BottomBar>
    </>
  );
};
